import React from 'react';

import { CommunityType } from 'types/communities';

import { useShopRequestModalContext } from './ShopRequestModalContext';
import { MYSTERY_SHOP_MODAL_REQUEST_FROM } from '../constants';
import ShopRequestStyledSelect from '../ShopRequestStyledSelect';

type Props = {
  communities: CommunityType[];
  value: number | null;
  loading?: boolean;
  disabled?: boolean;
  width: string;
  placeholder?: string;
  onChange: (value: any) => void;
  onSearch?: (input: string) => void;
};

const ShopRequestModalDropdown = ({
  communities,
  onChange,
  value,
  placeholder,
  loading = false,
  disabled = false,
  width,
  onSearch,
}: Props) => {
  const { requestFrom } = useShopRequestModalContext();
  const options = communities?.map((community: any) => ({ value: community?.id, label: community?.comunity_name }));
  const defaultPlaceholder =
    requestFrom === MYSTERY_SHOP_MODAL_REQUEST_FROM.FURTHER ? 'Select another community' : 'Select another competitor';

  const performChange = (newValue: number) => {
    const community = communities?.find((el) => el.id === newValue);
    if (community) {
      onChange(community);
    }
  };

  return (
    <ShopRequestStyledSelect
      placeholder={placeholder || defaultPlaceholder}
      options={options}
      onChange={performChange}
      value={value}
      loading={loading}
      disabled={disabled}
      width={width}
      // search should be handled by backend to allow fuzzy searching
      showSearch
      filterOption={(input, option) =>
        Boolean(option?.label) &&
        typeof option?.label === 'string' &&
        option.label.toLowerCase().includes(input.toLowerCase())
      }
      onSearch={(input) => {
        // Check if any local option matches
        const hasLocalMatch = (options ?? []).some(
          (opt) => typeof opt.label === 'string' && opt.label.toLowerCase().includes(input.toLowerCase())
        );

        // When there is no local match, search should be handled by backend
        if (input && !hasLocalMatch && typeof onSearch === 'function') {
          onSearch(input);
        }
      }}
    />
  );
};

export default ShopRequestModalDropdown;
